import React from "react";

import DateUtil from "../../common/dateUtil";
import DataRenderer from "../../common/dataRenderer";
import StatusComp from "../../common/StatusComp";
import CommentComp from "../common/CommentComp";
import { isJwCole, isSteward } from "../../common/checkClient";

const PoliticalDetail = (props)=>{
    const DefaultDetail = ()=>{
        return(
            
                <div className="panel-columns">

                    <div className="panel-column">
                    
                    {props.data.status && 
                    <div className="panel-item">
                        <div className="panel-item-label">Approval Status :</div>
                        <div className="panel-item-value"><StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                    </div>
                    }
                        <div className="panel-item">
                            <div className="panel-item-label">Type of Request :</div>
                            <div className="panel-item-value">{DataRenderer.RenderPoliticalContribType(props.data.contribType)}</div>
                        </div>

                        <div className="panel-item">
                            <div className="panel-item-label">Contribution Date or Planned For :</div>
                            <div className="panel-item-value">{props.mode==="DETAIL"?props.data.contribDate:DateUtil.toStrDate(props.data.contribDate)}</div>
                        </div>
                        <div className="panel-item">
                            <div className="panel-item-label">Description :</div>
                            <div className="panel-item-value">{props.data.description}</div>
                        </div>
                        {props.data.contribType === 'Contribution' &&
                        <div className="panel-item">
                            <div className="panel-item-label">State/Province :</div>
                            <div className="panel-item-value">{props.data.stateProv}</div>
                        </div>
                        }
                        <div className="panel-item">
                            <div className="panel-item-label">Contribution Amount :</div>
                            <div className="panel-item-value">{props.data.contribAmount}</div>
                        </div>

                        <div className="panel-item">
                            <div className="panel-item-label">Currency :</div>
                            <div className="panel-item-value">{props.data.currency}</div>
                        </div>
                    </div>
                    
                    <div className="panel-column">
                        {props.data.contribType === 'Contribution' &&
                        <div>
                            <div className="panel-item">
                                <div className="panel-item-label">Requires MSRB Form G-37 :</div>
                                <div className="panel-item-value">{props.data.reqMsrb==='Y'?'Yes':'No'}</div>
                            </div>
                            <div className="panel-item">
                                <div className="panel-item-label">Political Party or Subdivision :</div>
                                <div className="panel-item-value">{props.data.politicalParty}</div>
                            </div>
                            <div className="panel-item">
                                <div className="panel-item-label">Individual or PAC :</div>
                                <div className="panel-item-value">{props.data.contribIndividualOrPac ?  
                                                props.data.contribIndividualOrPac==='IN'?'Individual':'PAC'
                                                : ''}</div>
                            </div>
                            {isSteward() && props.data.contribIndividualOrPac === "IN" &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Individual sought position level :</div>
                                    <div className="panel-item-value">{props.data.contribIndividualSoughtPosition ?  
                                                props.data.contribIndividualSoughtPosition==='ST'?'Local/State':'Federal'
                                                : ''}</div>
                                </div>
                            }
                            {isSteward() && props.data.contribIndividualOrPac === "IN" &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Individual holds an existing office :</div>
                                    <div className="panel-item-value">{props.data.contribIndividualHoldOffice==='Y'?'Yes':'No'}</div>
                                </div>
                            }
                            {isSteward() && props.data.contribIndividualHoldOffice === "Y" &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Individual held active position :</div>
                                    <div className="panel-item-value">{props.data.contribIndividualActivePosition ?  
                                                props.data.contribIndividualActivePosition==='ST'?'Local/State':'Federal'
                                                : ''}</div>
                                </div>
                            }
                            <div className="panel-item">
                                <div className="panel-item-label">Eligible to vote for the candidate :</div>
                                <div className="panel-item-value">{props.data.contributorEligibleToVote ?
                                                props.data.contributorEligibleToVote==='Y'?'Yes':'No'
                                                : ''}</div>
                            </div>
                            <div className="panel-item">
                                <div className="panel-item-label">Part of Bond Ballot Campaign? :</div>
                                <div className="panel-item-value">{(!props.data.campaign || props.data.isCampaign === 'N') ? 'No' : 'Yes'}</div>
                            </div>
                            <div className="panel-item">
                                <div className="panel-item-label">Specify Campaign:</div>
                                <div className="panel-item-value">{props.data.campaign}</div>
                            </div>
                        </div>
                        }

                        {props.data.contribType === 'Contribution' && props.data.officials && props.data.officials.filter(o => o.name !== '').length>0 &&
                            <div className="panel-item">
                                <div className="panel-item-label">Officials :</div>
                                <div className="panel-item-value">
                                <ul>
                                    <li className="flex bottom-line">
                                        <div className="flex-1 placeholder">Name</div>
                                        <div className="flex-1 placeholder">Title</div>
                                        <div className="flex-1 placeholder">Agency</div>
                                    </li>

                                    {props.data.officials.map((item,idx)=>{
                                        return (<li key={idx} className="flex bottom-line">
                                            <div className="flex-1">{item.name}</div>
                                            <div className="flex-1">{item.title}</div>
                                            <div className="flex-1">{item.agency}</div>
                                        </li>)
                                    })

                                    }
                                    <li>

                                    </li>

                                </ul>

                                    
                                </div>
                            </div>
                        }

                        {props.data.attachment && 
                            <div className="panel-item">
                                <div className="panel-item-label">Attachment Document :</div>
                                <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                            </div>
                        }

                        {props.data.employeeName &&
                            <div className="panel-item">
                                <div className="panel-item-label">Employee :</div>
                            <div className="panel-item-value">{props.data.employeeName}</div>
                            </div>
                        }
                        {props.data.submittedForLabel &&
                            <div className="panel-item">
                                <div className="panel-item-label">Submit On Behalf of :</div>
                                <div className="panel-item-value">{props.data.submittedForLabel}</div>
                            </div>
                        }
                        {props.data.submittedBy &&
                            <div className="panel-item">
                                <div className="panel-item-label">Submitted By :</div>
                                <div className="panel-item-value">{props.data.submittedBy}</div>
                            </div>
                        }
                        
                    </div>
                    

                </div>

            
        );
    };

    const JwColeDetail = ()=>{

        const Contribution = ()=>{
            return(
                <div className="panel-body">
                    <div className="panel-columns">

                        <div className="panel-column">
                        
                        {props.data.status && 
                        <div className="panel-item">
                            <div className="panel-item-label">Approval Status :</div>
                            <div className="panel-item-value"><StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                        </div>
                        }
                            <div className="panel-item">
                                <div className="panel-item-label">Type of Request :</div>
                                <div className="panel-item-value">{DataRenderer.RenderPoliticalContribType(props.data.contribType)}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Pre-Approval being submitted for :</div>
                                <div className="panel-item-value">{props.data.contributorType}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Last Name of your Spouse :</div>
                                <div className="panel-item-value">{props.data.spouseLastName}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Middle Name of your Spouse :</div>
                                <div className="panel-item-value">{props.data.spouseMiddleName}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">First Name of your Spouse :</div>
                                <div className="panel-item-value">{props.data.spouseFirstName}</div>
                            </div>
                            
                            <div className="panel-item">
                                <div className="panel-item-label">Please indicate the type of activity you are seeking pre-approval for :</div>
                                <div className="panel-item-value">{props.data.contribTarget}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Type of Organization :</div>
                                <div className="panel-item-value">{props.data.politicalOrganizationType}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">If Political Party, are you entitled to vote in this jurisdiction? :</div>
                                <div className="panel-item-value">{props.data.politicalPartyVoteJurisdiction}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Name of Organization :</div>
                                <div className="panel-item-value">{props.data.politicalOrganizationName}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Jurisdiction :</div>
                                <div className="panel-item-value">{props.data.politicalOrganizationJurisdiction}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Contribution Amount :</div>
                                <div className="panel-item-value">{props.data.contribAmount}</div>
                            </div>




                            <div className="panel-item">
                                <div className="panel-item-label">Have you made any prior Political Contributions during this election cycle? :</div>
                                <div className="panel-item-value">{props.data.isIndividualPriorContrib}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">If yes, please provide details :</div>
                                <div className="panel-item-value">{props.data.individualPriorContribDetail}</div>
                            </div>


                            <div className="panel-item">
                                <div className="panel-item-label">Date :</div>
                                <div className="panel-item-value">{props.mode==="DETAIL"?props.data.individualPriorContribDate:DateUtil.toStrDate(props.data.individualPriorContribDate)}</div>

                            </div>
                           

                            <div className="panel-item">
                                <div className="panel-item-label">Amount Contributed :</div>
                                <div className="panel-item-value">{props.data.individualPriorContribAmount}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Campaign/Organization :</div>
                                <div className="panel-item-value">{props.data.individualPriorContribCampaignOrganization}</div>
                            </div>



                        </div>
                        
                        <div className="panel-column">

                            <div className="panel-item">
                                <div className="panel-item-label">Name of the Candidate :</div>
                                <div className="panel-item-value">{props.data.candidateName}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Office Sought :</div>
                                <div className="panel-item-value">{props.data.officeSought}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Date of Election :</div>
                                <div className="panel-item-value">{props.mode==="DETAIL"?props.data.electionDate:DateUtil.toStrDate(props.data.electionDate)}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Jurisdiction of Office sought :</div>
                                <div className="panel-item-value">{props.data.officeSoughtJurisdiction}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Type of Election :</div>
                                <div className="panel-item-value">{props.data.electionType}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Office currently held(if any) :</div>
                                <div className="panel-item-value">{props.data.officeHeld}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Are you, in any way, associated with the Candidate, Government Agency, OR Municipality? :</div>
                                <div className="panel-item-value">{props.data.isCandidateAssociated}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">If Yes, please explain :</div>
                                <div className="panel-item-value">{props.data.candidateAssociatedDesc}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Is the Candidate a client of yours or JW Cole? :</div>
                                <div className="panel-item-value">{props.data.isCandidateClient}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Type of Contribution :</div>
                                <div className="panel-item-value">{props.data.contribPaymentType}</div>
                            </div>





                            <div className="panel-item">
                                <div className="panel-item-label">Amount of Contribution :</div>
                                <div className="panel-item-value">{props.data.candidateContribAmount}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">If the above amount will be paid in other form than cash or check, please indicate the form that will be used :</div>
                                <div className="panel-item-value">{props.data.otherPaymentMethod}</div>
                            </div>
                            <div className="panel-item">
                                <div className="panel-item-label">If in-kind, please explain :</div>
                                <div className="panel-item-value">{props.data.otherContribMethod}</div>
                            </div>
                            
                            <div className="panel-item">
                                <div className="panel-item-label">Contribution or Planned For Date :</div>
                                <div className="panel-item-value">{props.mode==="DETAIL"?props.data.contribDate:DateUtil.toStrDate(props.data.contribDate)}</div>
                            </div>

                            {props.data.attachment && 
                                <div className="panel-item">
                                    <div className="panel-item-label">Attachment Document :</div>
                                    <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                                </div>
                            }
                            {props.data.employeeName &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Employee :</div>
                                    <div className="panel-item-value">{props.data.employeeName}</div>
                                </div>
                            }
                            {props.data.submittedForLabel &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Submit On Behalf of :</div>
                                    <div className="panel-item-value">{props.data.submittedForLabel}</div>
                                </div>
                            }
                            {props.data.submittedBy &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Submitted By :</div>
                                    <div className="panel-item-value">{props.data.submittedBy}</div>
                                </div>
                            }
                        </div>
                        

                    </div>

                </div>
            );
        };

        const Donation =()=>{
            return(
                
                    <div className="panel-columns">

                        <div className="panel-column">
                        
                        {props.data.status && 
                        <div className="panel-item">
                            <div className="panel-item-label">Approval Status :</div>
                            <div className="panel-item-value"><StatusComp status={props.data.status}>{props.data.statusLabel}</StatusComp></div>
                        </div>
                        }
                            <div className="panel-item">
                                <div className="panel-item-label">Type of Request :</div>
                                <div className="panel-item-value">{DataRenderer.RenderPoliticalContribType(props.data.contribType)}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Name of the Person/Entity the money is being raised for :</div>
                                <div className="panel-item-value">{props.data.politicalOrganizationName}</div>
                            </div>                       
                            
                            <div className="panel-item">
                                <div className="panel-item-label">Type of Person Entity you/spouse are raising money for :</div>
                                <div className="panel-item-value">{props.data.politicalOrganizationType}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Office Sought :</div>
                                <div className="panel-item-value">{props.data.officeSought}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Jurisdiction :</div>
                                <div className="panel-item-value">{props.data.officeSoughtJurisdiction}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Office currently held(if any) :</div>
                                <div className="panel-item-value">{props.data.officeHeld}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Date of Election :</div>
                                <div className="panel-item-value">{props.mode==="DETAIL"?props.data.electionDate:DateUtil.toStrDate(props.data.electionDate)}</div>
                            </div>


                        </div>
                        
                        <div className="panel-column">

                            <div className="panel-item">
                                <div className="panel-item-label">Description of Activity :</div>
                                <div className="panel-item-value">{props.data.description}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Will you make expenditures from personal funds in connection with the activity? :</div>
                                <div className="panel-item-value">{props.data.contributePersonalFund}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Will you engage in the activity during working hours :</div>
                                <div className="panel-item-value">{props.data.engagementInWorkingHours}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">How many hours will you engage in this activity during working hours :</div>
                                <div className="panel-item-value">{props.data.engagementHours}</div>
                            </div>

                            <div className="panel-item">
                                <div className="panel-item-label">Will you be using any company resources(office space, personnel(i.e., administrative assistants), equipment, phones, copiers or computers? :</div>
                                <div className="panel-item-value">{props.data.usingOfficeResource}</div>
                            </div>
                            <div className="panel-item">
                                <div className="panel-item-label">Contribution or Planned For Date :</div>
                                <div className="panel-item-value">{props.mode==="DETAIL"?props.data.contribDate:DateUtil.toStrDate(props.data.contribDate)}</div>
                            </div>
                            {props.data.attachment && 
                                <div className="panel-item">
                                    <div className="panel-item-label">Attachment Document :</div>
                                    <div className="panel-item-value">{props.data.attachment.fileName?props.data.attachment.fileName:props.data.attachment.name}</div>
                                </div>
                            }
                            {props.data.submittedForLabel &&
                                <div className="panel-item">
                                    <div className="panel-item-label">Submit On Behalf of :</div>
                                    <div className="panel-item-value">{props.data.submittedForLabel}</div>
                                </div>
                            }
                        </div>
                        

                    </div>

                
            );
        };

        return (
            <>
            {(props.data.contribType === "Contribution") && <Contribution/>}
            {(props.data.contribType === "Donation") && <Donation/>}
            </>
        )
        
    
    };

    return (
        <div className="panel-body">
            {!isJwCole() && <DefaultDetail mode="DETAIL"/>}
            {isJwCole() && <JwColeDetail mode="DETAIL"/>}
            
            <CommentComp data = {props.data.comments}/>

        </div>
    );

};


export default PoliticalDetail;

